import * as util from "./util.js";
const IndexDBStore = class IndexDBStore {
  dbname: string;
  promise: Promise<void | IDBDatabase> | undefined;

  constructor(dbname: string) {
    this.dbname = dbname;

    this.promise = new Promise((accept, reject) => {
      //check for support
      if (!("indexedDB" in window)) {
        throw new Error("This browser doesn't support IndexedDB");
      }

      const res = indexedDB.open(this.dbname, 5);

      res.onupgradeneeded = () => {
        const upgradeDb = res.result;

        upgradeDb.onerror = (event: Event) => {
          console.warn("IndexedDBError", event);
          reject();
        };

        if (!upgradeDb.objectStoreNames.contains(this.dbname)) {
          console.log("creating idb database. . .");

          const store = upgradeDb.createObjectStore(this.dbname, { keyPath: "_key" });

          store.createIndex("index", "data", {});
        }
      };

      res.onsuccess = () => {
        const db = res.result;
        const tx = db.transaction(this.dbname, "readwrite");
        const store = tx.objectStore(this.dbname);

        const countReq = store.count();
        countReq.onsuccess = () => {
          if (countReq.result == 0) {
            store.add({ _key: 0 });
          }
        };

        tx.oncomplete = () => {
          this.promise = undefined;
          accept();
        };

        tx.onerror = () => {
          this.promise = undefined;
          reject();
        };
      };
    });
  }

  _connect(): Promise<void | IDBDatabase> {
    const promise = this.promise;

    this.promise = new Promise((accept, reject) => {
      const connect = () => {
        const res = indexedDB.open(this.dbname, 5);
        res.onsuccess = () => {
          const db = res.result;

          accept(db);
        };

        res.onerror = () => {
          this.promise = undefined;
          reject(res.error);
        };
      };

      if (promise !== undefined) {
        promise.then(connect);
      } else {
        connect();
      }
    });

    this.promise.then((db) => {
      this.promise = undefined;
    });

    return this.promise;
  }

  write(key: string, val: unknown) {
    return new Promise((accept, reject) => {
      this._connect().then((db) => {
        const tx = (db as IDBDatabase).transaction(this.dbname, "readwrite");
        const store = tx.objectStore(this.dbname);
        const req = store.getAll();

        req.onsuccess = () => {
          let data = req.result as any;
          if (data.length == 0) {
            data = { _key: 0 };
          } else {
            data = data[0];
          }

          data[key] = val;
          store.put(data);
        };
      });
    });
  }

  keys(): Promise<string[]> {
    return new Promise((accept, reject) => {
      this._connect().then((db) => {
        const tx = (db as IDBDatabase).transaction(this.dbname, "readwrite");
        const store = tx.objectStore(this.dbname);
        const req = store.getAll();

        req.onsuccess = () => {
          let data = req.result as any;
          if (data.length == 0) {
            data = { _key: 0 };
          } else {
            data = data[0];
          }

          const keys = [];
          for (const k of Object.keys(data)) {
            if (k !== "_key") {
              keys.push(k);
            }
          }

          accept(keys);
        };
      });
    });
  }

  read(key: string, val?: unknown) {
    return new Promise((accept, reject) => {
      this._connect().then((db) => {
        const tx = (db as IDBDatabase).transaction(this.dbname, "readwrite");
        const store = tx.objectStore(this.dbname);
        const req = store.getAll();

        req.onsuccess = () => {
          let data = req.result as any;
          if (data.length == 0) {
            data = { _key: 0 };
          } else {
            data = data[0];
          }

          accept(data[key]);
        };
      });
    });
  }
};

let test_idgen = 0;
const test = function () {
  const store = new IndexDBStore("test");
  store.write("bleh", [test_idgen++, 1, 2, 3]);

  store.read("bleh").then((val) => {
    console.log(val);
  });

  store.keys().then((keys) => {
    console.log(keys);
  });
};
const readTest = function () {
  const store = new IndexDBStore("test");

  store.keys().then((keys) => {
    console.log(keys);
  });
};

export { IndexDBStore, test, readTest };
